/**
 * data/index.js — STATIC SEED REFERENCE (not the live data source)
 *
 * ⚠️  These course definitions are kept as:
 *   1. A fallback for offline development (used by useCourse.js when the API is unreachable)
 *   2. A seed reference for the one-time MongoDB migration
 *
 * The LIVE source of truth is MongoDB, accessed via GET /api/courses/:slug.
 * To update course content in production, use the Admin → Courses dashboard.
 *
 * DO NOT add new courses here — add them via the Admin dashboard instead.
 */

import dataScienceCourse from './courses/dataScienceCourse';
import dataAnalyticsCourse from './courses/dataAnalyticsCourse';
import dataEngineeringCourse from './courses/dataEngineeringCourse';
import webDevelopmentCourse from './courses/webDevelopmentCourse';
import digitalMarketingCourse from './courses/digitalMarketingCourse';

// Keyed by slug — matches the :courseType URL param and the MongoDB `slug` field
const internshipCoursesData = {
  'data-science': dataScienceCourse,
  'data-analytics': dataAnalyticsCourse,
  'data-engineering': dataEngineeringCourse,
  'web-development': webDevelopmentCourse,
  'digital-marketing': digitalMarketingCourse,
};

export default internshipCoursesData;

// Named exports preserved for any remaining direct imports
export {
  dataScienceCourse,
  dataAnalyticsCourse,
  dataEngineeringCourse,
  webDevelopmentCourse,
  digitalMarketingCourse,
};